import { createElement, forwardRef } from 'react';
import { PredefinedButtonProps, PredefinedButtonType } from '.';
import { Button, ButtonProps, ButtonVariant } from '../../Button';
import { SVGIconDescriptor } from '../../SVG';
import { Localizer } from '../../../locale/useTextLocalizer';
import bundle from '../NovaComponents-Toolbar-gui-icu.properties';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';

import {
  Open,
  NewStarburst,
  Edit,
  Delete,
  Save,
  SaveAs,
  Upload,
  Download,
  Refresh,
  Reset,
  Undo,
  Redo,
  Filter,
  Attach,
  Add,
  Import,
  Export,
} from '@sas/react-svg';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const PredefinedButton = forwardRef<HTMLButtonElement, PredefinedButtonProps>(
  function PredefinedButton({ type, iconOnly, ...props }, ref) {
    const localize = useTextLocalizer();
    const { icon, text } = getIconText(type, iconOnly, localize);
    const defaultVariant = iconOnly ? ButtonVariant.Icon : undefined;
    return (
      <Button
        {...props}
        ref={ref}
        icon={icon}
        text={text}
        variant={props.variant ?? defaultVariant}
      />
    );
  }
);

export const getIconText = (
  type: PredefinedButtonType,
  iconOnly = false,
  localize: Localizer
): { icon?: ButtonProps['icon']; text?: string } => {
  let icon: SVGIconDescriptor;
  let text: string;
  switch (type) {
    case 'open':
      icon = Open;
      text = localize('predefinedButton.open.button.label');
      break;
    case 'new':
      icon = NewStarburst;
      text = localize('predefinedButton.new.button.label');
      break;
    case 'edit':
      icon = Edit;
      text = localize('predefinedButton.edit.button.label');
      break;
    case 'delete':
      icon = Delete;
      text = localize('predefinedButton.delete.button.label');
      break;
    case 'save':
      icon = Save;
      text = localize('predefinedButton.save.button.label');
      break;
    case 'saveAs':
      icon = SaveAs;
      text = localize('predefinedButton.saveAs.button.label');
      break;
    case 'upload':
      icon = Upload;
      text = localize('predefinedButton.upload.button.label');
      break;
    case 'download':
      icon = Download;
      text = localize('predefinedButton.download.button.label');
      break;
    case 'refresh':
      icon = Refresh;
      text = localize('predefinedButton.refresh.button.label');
      break;
    case 'reset':
      icon = Reset;
      text = localize('predefinedButton.reset.button.label');
      break;
    case 'undo':
      icon = Undo;
      text = localize('predefinedButton.undo.button.label');
      break;
    case 'redo':
      icon = Redo;
      text = localize('predefinedButton.redo.button.label');
      break;
    case 'filter':
      icon = Filter;
      text = localize('predefinedButton.filter.button.label');
      break;
    case 'attach':
      icon = Attach;
      text = localize('predefinedButton.attach.button.label');
      break;
    case 'add':
      icon = Add;
      text = localize('predefinedButton.add.button.label');
      break;
    case 'import':
      icon = Import;
      text = localize('predefinedButton.import.button.label');
      break;
    case 'export':
      icon = Export;
      text = localize('predefinedButton.export.button.label');
      break;
  }
  return { icon: iconOnly ? { icon } : undefined, text: iconOnly ? undefined : text };
};
